import React, { useState, useEffect, useCallback, useMemo } from "react";

import { styled } from "@mui/material/styles";

import {
  Box,
  Paper,
  Container,
  Button,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  IconButton,
  Typography,
  Select,
  Divider,
  Tooltip,
  makeStyles,
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import { tableCellClasses } from "@mui/material/TableCell";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import debouce from "lodash.debounce";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import employeeIcon from "../../img/employee_icon.svg";
import employeeOnOD from "../../img/employee_on_od.svg";
import totalODIcon from "../../img/total_od.svg";

import activeIcon from "../../icons/active.svg";
import inactiveIcon from "../../icons/inactive.svg";

import MeetingCompleted from "../../icons/Meeting-Completed.svg";
import NewCustomer from "../../icons/New-Customer.svg";
import OldCustomers from "../../icons/Old-Customers.svg";
import TotalCompleted from "../../icons/Total-Completed-OD.svg";
import Redirect from "../../icons/Redirect.svg";

import "./InfhoWindow.css";

import CloseIcon from "@mui/icons-material/Close";

import MapComponent from "./Map";

import { DashboardAction } from "../../actions/dashboard";

import { SummaryAction } from "../../actions/summary";

import CircleIcon from "@mui/icons-material/Circle";

import { useNavigate } from "react-router-dom";

import moment from "moment";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useSelector, useDispatch } from "react-redux";
import { empWise, meetingReport } from "./redirectSlice";
import { Refresh, Search, SearchOutlined } from "@mui/icons-material";
import { useRef } from "react";
import { ScheduledAction } from "../../actions/ScheduledMeting";
import { dynamiceForm } from "../../actions/DynamiceForm";
import liveIcon from "../../img/live.png";
import androidPng from "../../img/android.png";
import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";
import RestoreIcon from "@mui/icons-material/Restore";
import { useLocalStorage } from "../../Hooks/Index";

const theme = createTheme({
  palette: {
    primary: {
      main: "#082e6c",
    },
    // sky: {
    //   skyblue: "#082e6c",
    // },
  },
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#50ADD3",
    color: theme.palette.common.dark,
    border: "1px solid #fff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const Dashboard = () => {
  const localData = JSON.parse(localStorage.getItem("data")) || {};
  const Templatedata =
    localStorage.getItem("Templatedata") &&
    JSON.parse(localStorage.getItem("Templatedata"));
  const totalCompletedODLabel =
    (Templatedata &&
      Templatedata.length > 0 &&
      Templatedata.find((header) => header.actualName === "Total Completed OD")
        ?.displayName) ||
    "Total Completed OD";

  const scheduledMeetingLabel =
    (Templatedata &&
      Templatedata.length > 0 &&
      Templatedata.find((header) => header.actualName === "Scheduled Meeting")
        ?.displayName) ||
    "Scheduled Meeting";
  const NewClient =
    Templatedata &&
    Templatedata.length > 0 &&
    Templatedata.filter((val) => {
      return val.actualName === "New Client";
      //  alert("2")
    });
  const existingClient =
    Templatedata &&
    Templatedata.length > 0 &&
    Templatedata.filter((val) => {
      return val.actualName === "Existing Client";
    });
  // const [TemplateData,setTempalteData]=useState(Templatedata)
  // console.log(TemplateData)

  const [userInfoTotal, setUserInfoTotal] = useState([]);
  const [userInfo, setUserInfo] = useState([]);
  const [singleUser, setSingleUser] = useState(false);
  const [singleDataShowOnMap, setSingleDataShowOnMap] = useState([]);
  const [bound, setBound] = useState(null);
  const [searchValueData, setSearchValueData] = useState([]);
  const [scheduledMeting, setScheduledMeting] = useState([]);
  const [fromDate, setFromDate] = useState(
    moment(new Date()).format("YYYY-MM-DD"),
  );
  const [toDate, setToDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [search, setSearch] = useState("");
  const [totalOD, setTotalOD] = useState(0);
  const [clientcommunicatin, setClientcommunicatin] = useState([]);
  const [activeOd, setActiveOd] = useState("");
  const [inActiveOd, setInActiveOd] = useState("");
  const [filteredata, setFilteredata] = useState();
  const [activeColor, setActiveColor] = useState("");
  const serachvalue = useRef(null);
  const [clinetTitle, setClientSatatus] = useState({
    clientMeeting: "",
    existingClient: "",
    newClient: "",
    nearestClient: "",
    leadsClient: "",
    addleadsClient: "",
    comformationAddClient: "",
    selectClient: "",
    client: "",
    filterNames: "",
    selectClientOwner: "",
    newClients: "",
    uniqueClients: "",
  });
  const [newClientTitle, setNewClientTitle] = useState(
    NewClient && NewClient.length > 0 && NewClient[0].displayName
      ? NewClient[0].displayName
      : "New Client",
  );
  const [ExitingClientTitle, setExitingNewClientTitle] = useState(
    existingClient && existingClient.length > 0 && existingClient[0].displayName
      ? existingClient[0].displayName
      : "Existing Client",
  );

  const [selectedSite] = useLocalStorage("selectedSite", null);

  const navigate = useNavigate();

  // userInfoTotal.userDtoList.map((data) => {
  // });
  // useEffect(()=>{
  //   if(search.length ===16){
  //     serachvalue.current.focus()
  //   }

  // },[search.length])
  // userInfoTotal.userDtoList.forEach((user) => {
  //   if (user.isODOn) {
  //     empOnOD++;
  //   }
  //   if (!user.isODOn) {
  //     empOffOD++;
  //   }
  //   if (!user.isODCompleted) {
  //     isODCompleted++;
  //   }
  // });

  const liveTracking = (id, running) => {
    window.open(`/live/${id}?v=${true}`, "_blank");
  };
  const fetchHederTitle = () => {
    // const NewClient =TemplateData !==null && TemplateData.filter((val) =>{
    //   debugger
    //  if( val.actualName === "New Client"){
    //   //  alert("2")
    //   return  setNewClientTitle(val.displayName)
    //  }
    // })
    // const existingClient =TemplateData !==null && TemplateData.filter((val) =>{
    //   if( val.actualName === "Existing Client"){
    //    return  setExitingNewClientTitle(val.displayName)
    //   }
    //  })
  };
  // console.log(TemplateData,"TemplateData")

  const fetchScheduledMetingData = () => {
    const data = {
      usersHrmsId: JSON.parse(localStorage.getItem("data"))?.hrmsUserId,
      hrmsCompanyId: JSON.parse(localStorage.getItem("data"))?.hrmsCompanyId,
      fromDate: fromDate,
      toDate: toDate,
      assignedToList:
        userInfo !== null
          ? userInfo?.hrmsUserId
            ? [userInfo?.hrmsUserId]
            : null
          : null,
      userId: JSON.parse(localStorage.getItem("data")).id,
    };
    ScheduledAction.fetchScheduledMetingForDasboard(data).then((response) => {
      if (response !== null) {
        setScheduledMeting(response.data);
      } else {
        console.log("error");
      }
    });
  };

  const fetchUsersInfo = async (flag) => {
    const hrmsUserId = JSON.parse(localStorage.getItem("data"))?.hrmsUserId;
    const data = {
      companyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
      hrmsUserId: hrmsUserId,
      userId: JSON.parse(localStorage.getItem("data")).id,
      fromDate: fromDate,
      toDate: toDate,
    };
    if (hrmsUserId) {
      const res = await DashboardAction.fetchUserInfo(data);
      if (res !== null) {
        if (res.responseCode === 200) {
          setUserInfoTotal(res.data);

          setUserInfo(res.data.userDtoList);

          setActiveColor("all");
          const activeOdArray =
            res.data &&
            res.data.userDtoList &&
            res.data.userDtoList.filter((ele) => {
              return ele.isODOn == true;
            });
          const inActiveOd =
            res.data &&
            res.data.userDtoList &&
            res.data.userDtoList.filter((ele) => {
              return ele.isODOn !== true;
            });
          setActiveOd(activeOdArray.length);
          setInActiveOd(inActiveOd.length);
        } else if (res.responseCode === 204) {
          if (flag) {
            alert(res.responseDescription);
          }
        }
      }
    }
  };

  const refreshCache = async (flag) => {
    const hrmsUserId = JSON.parse(localStorage.getItem("data"))?.hrmsUserId;
    const data = {
      companyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
      hrmsUserId: hrmsUserId,
      userId: JSON.parse(localStorage.getItem("data")).id,
      fromDate: fromDate,
      toDate: toDate,
    };
    if (hrmsUserId) {
      const res = await DashboardAction.fetchRefreshCache(data);
      if (res !== null) {
        fetchUsersInfo();
        fetchScheduledMetingData();
      }
    }
  };
  // const client_communicatindata = () => {
  //   let data = {
  //     fromDate: moment().format("YYYY-MM-DD"),
  //     toDate: moment().format("YYYY-MM-DD"),
  //     userId: JSON.parse(localStorage.getItem("data")).id,
  //     hrmsUserId: JSON.parse(localStorage.getItem("data")).hrmsUserId,
  //   };
  //   DashboardAction.client_communicatin(data).then((response) => {
  //     if (response !== null) {
  //       setClientcommunicatin(response.data);
  //     } else {
  //       console.log("error");
  //     }
  //   });
  // };
  // window.onload=function(){
  //   document.getElementById("input").focus()
  // }
  //   const onchnagedata=(event)=>
  // {
  //     const value = event.target.value;
  //     document.getElementById("label").innerText = value;
  // }
  const handleChange = (e) => {
    console.log(e.target.value, "fghjk");
    setSearch(e.target.value);
  };
  // const handleInput=(e)=>{
  //   setSearch(e.target.value)
  //   document.getElementById("input").focus()
  // }
  //   const handleSearch = (e) => {
  //     e.preventDefault();
  //     setSearch(e.target.value);

  //     // if (value === "") {
  //     //   setUserInfo(userInfoTotal.userDtoList);
  //     // } else {
  //     //   const regex = new RegExp(value, "gi");
  //     //   const filteredUserInfo = userInfoTotal.userDtoList.filter((user) =>
  //     //     regex.test(user.name ) || regex.test(user.empCode)
  //     //   );
  //     //   setUserInfo(filteredUserInfo);
  //     // }
  //   };
  const getFilteredPatients = useCallback(() => {
    debugger;
    if (!search) {
      return setUserInfo(userInfoTotal.userDtoList);
    } else if (search) {
      debugger;
      const filteredUserInfo = userInfoTotal.userDtoList.filter(
        //(user) => regex.test(user.name) || regex.test(user.empCode)
        (user) =>
          user.name?.toLowerCase()?.trim().includes(search.toLowerCase()) ||
          user.empCode?.toLowerCase()?.trim().includes(search.toLowerCase()),
      );
      document.getElementById("input").focus();
      setUserInfo(filteredUserInfo);
      //setSearchValueData(filteredUserInfo);
    }
  }, [search]);

  const debouncedResults = useMemo(() => {
    return debouce(handleChange, 300);
  }, []);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  });

  // const getFilteredPatients1=() => {
  //   const regex = new RegExp(search, "gi");
  //   if (!search) {
  //     return setUserInfo( userInfoTotal.userDtoList)
  //   } else if (search) {
  //      const filteredUserInfo=  userInfoTotal.userDtoList.filter(
  //       (user) => regex.test(user.name) || regex.test(user.empCode)
  //     );
  //      setUserInfo(filteredUserInfo);
  //     //setSearchValueData(filteredUserInfo);
  //   }
  // }

  //  const userListData=getFilteredPatients1()

  // const getFilteredPatients = () => {
  //   debugger
  //   if (!search) {
  //     return setUserInfo(userInfoTotal.userDtoList);
  //   } else if (search) {
  //     const filteredUserInfo = userInfoTotal.userDtoList.filter((user) =>
  //       user.name.toLowerCase().trim().includes(search.toLowerCase())
  //     );
  //     setUserInfo(filteredUserInfo);
  //     //setSearchValueData(filteredUserInfo);
  //   }

  // };

  const handleBound = (user) => {
    setSingleUser(true);
    setSingleDataShowOnMap([user]);
    if (user.latitude && user.longitude) {
      setBound({
        lat: user.latitude,
        lng: user.longitude,
      });
    } else {
      alert(`Employee location not found for ${user.name}`);
    }
  };

  const getSummaryData = async () => {
    const payload = {
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      employeeId: 0,
      // userId:,
      // hrmsUserId
      userId: JSON.parse(localStorage.getItem("data")).id,
      hrmsUserId: JSON.parse(localStorage.getItem("data")).hrmsUserId,
    };
    const res = await SummaryAction.FetchSummaryList(payload);
    if (res !== null && res.responseCode === 200) {
      const totalODCount =
        res.data &&
        res.data.dataList &&
        res.data.dataList.reduce((total, currVal) => {
          if (currVal?.clientCommunicationDtoList?.length) {
            return total + currVal.clientCommunicationDtoList.length;
          } else {
            return 0;
          }
        }, 0);
      setTotalOD(totalODCount);
    } else {
      // no code here
    }
  };
  // useEffect(()=>{

  //     fetchHederTitle();
  // },[])
  useEffect(() => {
    fetchUsersInfo(true);
    //getSummaryData()
    fetchScheduledMetingData();
    // client_communicatindata();
    const id = setInterval(() => {
      if (search !== "") {
        fetchUsersInfo(false);
      }

      // client_communicatindata();
    }, 30000);
    return () => {
      clearInterval(id);
    };
  }, [selectedSite]);

  useEffect(() => {
    getFilteredPatients();
    // handleSearch(search);
  }, [search]);

  const filterEmployeehandler = (data) => {
    setSingleUser(false);
    const employeeList = userInfoTotal.userDtoList;
    let filterArray = [];
    if (data == "active") {
      setActiveColor("active");
      filterArray = employeeList.filter((ele) => {
        return ele.isODOn == true;
      });
    } else if (data == "inactive") {
      setActiveColor("inactive");
      filterArray = employeeList.filter((ele) => {
        return ele.isODOn !== true;
      });
    } else {
      setActiveColor("all");
      filterArray = employeeList;
    }
    setUserInfo(filterArray);
  };

  let empOnOD = 0;
  let empOffOD = 0;
  let isODCompleted = 0;

  // if (userInfoTotal.userDtoList !== undefined) {
  // }

  // for (let data in userInfoTotal.userDtoList) {
  //   setUserInfo(userInfoTotal.userDtoList[data]);
  // }

  // for (let i = 0; i <= userInfoTotal.userDtoList.length; i++) {
  //   const element = array[i];
  // }
  const [imageUrl, setImageUrl] = useState();
  const [imagePopup, setImagePopup] = useState(false);
  const modalImageHandle = (imageUrl) => {
    setImageUrl(imageUrl);
    setImagePopup(true);
  };

  const dispatch = useDispatch();

  const totalMeetingsHandle = () => {
    dispatch(meetingReport());

    navigate("/outdoorduties");
  };
  const meetingReports = () => {
    dispatch(empWise());

    navigate("/outdoorduties");
  };
  const ScheduledRepots = () => {
    // dispatch(empWise());
    navigate("/scheduledMeting");
  };

  const RestoreOd = () => {
    // dispatch(empWise());
    navigate("/OdRestoreEmployee");
  };

  const communicateHandle = (user) => {
    // sessionStorage.setItem("navigatedOutdoordutiesFilter", true);
    sessionStorage.setItem("navigatedOutdoordutiesFilter", user.id);
    navigate(`/outdoorduties/${user.id}`);
  };

  const handleTrackLive = (user) => {
    const obj = {
      userId: user?.id,
      filterUserId: user?.id,
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };
    localStorage.setItem("singleDetail", JSON.stringify(obj));
    localStorage.setItem("userDataForLiveTracking", JSON.stringify(user));
    window.open(`/details/${user?.id}?ILS=${true}`, "_blank");
  };

  const fetchUsersInfoIntervalRef = React.useRef(null);

  useEffect(() => {
    if (fetchUsersInfoIntervalRef.current) {
      clearInterval(fetchUsersInfoIntervalRef.current);
      fetchUsersInfoIntervalRef.current = null;
    }

    let parsedData = null;
    try {
      const rawData = localStorage.getItem("data");
      if (rawData) parsedData = JSON.parse(rawData);
    } catch (err) {
      console.error("Failed to parse 'data' from localStorage:", err);
      return;
    }

    const frequencyInMinutes = parsedData?.locationTrackingFrequency;
    const isTrackingEnabled = parsedData?.enableLiveTracking === true;

    if (
      isTrackingEnabled &&
      typeof frequencyInMinutes === "number" &&
      frequencyInMinutes > 0
    ) {
      // const frequencyInMs = frequencyInMinutes * 60 * 1000;
      const frequencyInMs = 30000;

      fetchUsersInfoIntervalRef.current = setInterval(() => {
        fetchUsersInfo(true);
      }, frequencyInMs);
    } else {
      console.warn(
        "Tracking not enabled or invalid frequency. Skipping fetchUsersInfo interval.",
      );
    }

    return () => {
      if (fetchUsersInfoIntervalRef.current) {
        clearInterval(fetchUsersInfoIntervalRef.current);
        fetchUsersInfoIntervalRef.current = null;
      }
    };
  }, [selectedSite]);

  return (
    <main className="contents__root">
      {/* {imagePopup && (
        <div className="image_popup">
          <div className="overlays" onClick={() => setImagePopup(false)}></div>
          <div className="imageMain">
            <Button sx={{ color: "#fff" }} onClick={() => setImagePopup(false)}>
              <CloseIcon />
            </Button>
            {imageUrl === null ? (
              <AccountCircleIcon
                sx={{
                  fontSize: "2rem",
                  marginRight: "0.9rem",
                  marginLeft: "0.9rem",
                }}
              />
            ) : (
              <img src={imageUrl}></img>
            )}
          </div>
        </div>
      )} */}
      <ThemeProvider theme={theme}>
        <Box>
          <Box className="Dasboard">
            <Grid
              container
              // spacing={1}
              sx={{
                ".MuiButton-root": {
                  width: "100%",
                  background: "red",
                },
              }}
              xs={12}
            >
              <Grid item md={3}>
                <Box className="left_status">
                  <Box
                    className="status_box"
                    sx={{ backgroundColor: "#f2d50040" }}
                  >
                    <h5 className="status_title">Total Emp</h5>
                    <div className="num">
                      {userInfoTotal && userInfoTotal.userDtoList
                        ? userInfoTotal.userDtoList.length
                        : 0}
                    </div>
                  </Box>
                  <Tooltip title="Employees who are on OD">
                    <Box
                      className="status_box"
                      sx={{ backgroundColor: "#a9d73940" }}
                    >
                      <h5 className="status_title">
                        Active <img src={activeIcon} alt="Active"></img>
                      </h5>

                      <div className="num">{activeOd ? activeOd : 0}</div>
                    </Box>
                  </Tooltip>
                  <Tooltip title="Employees who are not in OD">
                    <Box
                      className="status_box"
                      sx={{ backgroundColor: "#E22B2B40" }}
                    >
                      <h5 className="status_title">
                        Inactive <img src={inactiveIcon} alt="Inactive"></img>
                      </h5>
                      <div className="num">{inActiveOd ? inActiveOd : 0}</div>
                    </Box>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item md={9}>
                <Box className="right_status">
                  <Box
                    onClick={totalMeetingsHandle}
                    className="status_box"
                    sx={{ backgroundColor: "#f2d50040" }}
                  >
                    <h5 className="status_title">Total Meetings </h5>
                    <Box
                      display={"flex"}
                      justifyContent="space-between"
                      alignItems={"flex-end"}
                    >
                      <div className="countbox">
                        <img src={MeetingCompleted}></img>
                        <div className="num">
                          {userInfoTotal && userInfoTotal.totalCompletedMeeting}
                        </div>
                      </div>
                      <img
                        src={Redirect}
                        className="redirect_icon"
                        alt=""
                      ></img>
                    </Box>
                  </Box>
                  <Box
                    className="status_box"
                    sx={{ backgroundColor: "#A9D73952" }}
                  >
                    <h5 className="status_title">
                      {localData?.isClientNameChanged
                        ? (
                            (newClientTitle !== ""
                              ? newClientTitle
                              : "New Client") + ""
                          )?.replace(
                            /client/gi,
                            localData?.changedClientFieldName || "Client",
                          )
                        : newClientTitle !== ""
                          ? newClientTitle
                          : "New Client"}
                    </h5>
                    <div className="countbox">
                      <img src={NewCustomer} alt=""></img>
                      <div className="num">
                        {userInfoTotal && userInfoTotal.newCustomerCount}
                      </div>
                    </div>
                  </Box>
                  <Box
                    className="status_box"
                    sx={{ backgroundColor: "#DAE2EE40" }}
                  >
                    <h5 className="status_title">
                      {/* {ExitingClientTitle !== ""
                        ? ExitingClientTitle
                        : "Existing Client"} */}
                      {localData?.isClientNameChanged
                        ? (
                            (ExitingClientTitle !== ""
                              ? ExitingClientTitle
                              : "Existing Client") + ""
                          )?.replace(
                            /client/gi,
                            localData?.changedClientFieldName || "Client",
                          )
                        : ExitingClientTitle !== ""
                          ? ExitingClientTitle
                          : "Existing Client"}
                    </h5>
                    <div className="countbox">
                      <img src={OldCustomers} alt=""></img>
                      <div className="num">
                        {userInfoTotal && userInfoTotal.oldCustomerCustomer}
                      </div>
                    </div>
                  </Box>
                  <Box
                    onClick={meetingReports}
                    className="status_box"
                    sx={{ backgroundColor: "#ECD0EF40" }}
                  >
                    <h5 className="status_title">{totalCompletedODLabel}</h5>
                    <Box
                      display={"flex"}
                      justifyContent="space-between"
                      alignItems={"flex-end"}
                    >
                      <div className="countbox">
                        <img src={TotalCompleted} alt=""></img>
                        <div className="num">
                          {userInfoTotal && userInfoTotal.totalCompletdOd}
                        </div>
                      </div>
                      <img
                        src={Redirect}
                        className="redirect_icon"
                        alt=""
                      ></img>
                    </Box>
                  </Box>
                  <Box
                    onClick={ScheduledRepots}
                    className="status_box"
                    sx={{ backgroundColor: "#ECD0EF40" }}
                  >
                    <h5 className="status_title">{scheduledMeetingLabel}</h5>
                    <Box
                      display={"flex"}
                      justifyContent="space-between"
                      alignItems={"flex-end"}
                    >
                      <div className="countbox">
                        <p
                          style={{
                            color: "blue",
                            display: "flex",
                            alignItems: "baseline",
                            gap: "5px",
                          }}
                        >
                          <span style={{ fontSize: "8px" }}>Total</span>
                          <span style={{ fontWeight: "700" }}>
                            {scheduledMeting
                              ? scheduledMeting.totalCommFollowUp
                              : 0}
                          </span>
                        </p>
                      </div>
                      <div className="countbox">
                        <p
                          style={{
                            color: "green",
                            display: "flex",
                            alignItems: "baseline",
                            gap: "5px",
                          }}
                        >
                          <span style={{ fontSize: "8px" }}>Completed</span>
                          <span style={{ fontWeight: "700" }}>
                            {scheduledMeting
                              ? scheduledMeting.totalCompletedCommFollowUp
                              : 0}
                          </span>
                        </p>
                      </div>
                      <div className="countbox">
                        <p
                          style={{
                            color: "rgb(156 140 29)",
                            display: "flex",
                            alignItems: "baseline",
                            gap: "5px",
                          }}
                        >
                          <span style={{ fontSize: "8px" }}>Scheduled</span>
                          <span style={{ fontWeight: "700" }}>
                            {scheduledMeting
                              ? scheduledMeting.totalScheduledCommFollowUp
                              : 0}
                          </span>
                        </p>
                      </div>
                    </Box>
                  </Box>
                  {Boolean(
                    JSON.parse(localStorage.getItem("data"))
                      .isCompanyConfigurationPermissionEnable,
                  ) && (
                    <Box
                      onClick={RestoreOd}
                      className="status_box"
                      sx={{ backgroundColor: "#ECD0EF40" }}
                    >
                      {/* <h5 className="status_title">OD restore</h5> */}
                      <h5 className="status_title">Configuration</h5>
                      <Box
                        display={"flex"}
                        justifyContent="space-between"
                        alignItems={"flex-end"}
                      >
                        <div className="countbox">
                          {/* <img src={TotalCompleted} alt=""></img> */}
                          <RestoreIcon sx={{ color: "#32577E" }} />
                          {/* <div className="num">
                            {userInfoTotal && userInfoTotal.totalCompletdOd}
                          </div> */}
                        </div>
                        <img
                          src={Redirect}
                          className="redirect_icon"
                          alt=""
                        ></img>
                      </Box>
                    </Box>
                  )}
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={1}
              sx={{ height: "calc(100vh - 182px)", overflow: "hidden" }}
            >
              <Grid item md={3} xs={12}>
                <Box className="tables">
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <StyledTableCell
                            className="main_table_header"
                            colSpan={2}
                          >
                            <Box
                              className="table_header"
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                // width: "70%",
                              }}
                            >
                              <div
                                className={`${
                                  activeColor == "all" ? "active" : ""
                                }`}
                                onClick={() => filterEmployeehandler("all")}
                              >
                                All
                              </div>
                              <div
                                className={` ${
                                  activeColor == "active" ? "active" : ""
                                }`}
                                onClick={() => filterEmployeehandler("active")}
                              >
                                Active
                              </div>

                              <div
                                className={` ${
                                  activeColor == "inactive" ? "active" : ""
                                }`}
                                onClick={() =>
                                  filterEmployeehandler("inactive")
                                }
                              >
                                Inactive
                              </div>
                            </Box>
                          </StyledTableCell>
                        </TableRow>
                      </TableHead>
                    </Table>
                  </TableContainer>
                  <TableContainer
                    className="table_scroll"
                    sx={{
                      minHeight: "auto",
                      background: "#fff",
                      borderRadius: "26px",
                      height: "calc(100vh - 245px)",
                    }}
                  >
                    <Table
                      className="left_table_body"
                      stickyHeader
                      size="small"
                      aria-label="sticky table"
                    >
                      <TableHead>
                        <TableRow>
                          <StyledTableCell
                            className="main_table_header"
                            colSpan={3}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "2px",
                                marginBottom: "10px",
                                marginTop: "7px",
                              }}
                            >
                              <TextField
                                className="searchBar"
                                label="Search"
                                type="text"
                                id="input"
                                // placeholder="Search User"
                                name=""
                                noWrap
                                sx={{
                                  ".MuiInputBase-root": {
                                    borderRadius: "100px",
                                    background: "#DAE2EE",
                                  },
                                }}
                                size="small"
                                fullWidth
                                // width="50%"
                                ref={(input) => input && input.focus()}
                                // autoFocus
                                focused
                                autoComplete="off"
                                onChange={debouncedResults}
                                // onInput={handleInput}

                                InputProps={{
                                  endAdornment: (
                                    <IconButton>
                                      <SearchOutlined />
                                    </IconButton>
                                  ),
                                }}
                              />
                              <Tooltip title="Refresh User" arrow>
                                <IconButton>
                                  <Refresh onClick={() => refreshCache()} />
                                </IconButton>
                              </Tooltip>
                              {/* <input type="text" onChange={debouncedResults} /> */}
                              {/* <SearchBar search={search} setSearch={setSearch} serachvalue={serachvalue} /> */}

                              {/* <input type="text" onInput={(e)=>onchnagedata()}/>
<span id="label">result</span> */}
                              {/* <FormControl fullWidth>
                                <NativeSelect
                                  className="border_btm"
                                  sx={{
                                    "& .MuiSvgIcon-root": { color: "#2A3478" },
                                    color: "#2A3478",
                                  }}
                                  id="tteam-wise"
                                  IconComponent={ExpandMoreIcon}
                                >
                                  <option value={10}>Team Wise</option>
                                  <option value={20}>Team Wise</option>
                                  <option value={30}>Team Wise</option>
                                </NativeSelect>
                              </FormControl> */}
                            </Box>
                          </StyledTableCell>
                        </TableRow>
                      </TableHead>
                      {/* <TableBody> */}
                      {userInfo &&
                        userInfo &&
                        userInfo.length > 0 &&
                        userInfo.map((user, index) => {
                          return (
                            <StyledTableRow
                              key={index}
                              hover
                              onClick={() => handleBound(user)}
                            >
                              <StyledTableCell
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "3px 16px",
                                }}
                              >
                                <div className="onod">
                                  {user.odStatus &&
                                  user.odStatus ===
                                    "OD_STARTED_AND_COMMUNICATION_SUBMITTED" ? (
                                    <IconButton size="small" color="success">
                                      <CircleIcon
                                        fontSize="small"
                                        sx={{
                                          width: "10px",
                                          marginLeft: "5px",
                                        }}
                                      />
                                    </IconButton>
                                  ) : user.odStatus ===
                                    "OD_STARTED_BUT_NO_COMMUNICATION" ? (
                                    <IconButton
                                      size="small"
                                      sx={{ color: "#E3C009" }}
                                    >
                                      <CircleIcon
                                        fontSize="small"
                                        sx={{
                                          width: "10px",
                                          marginLeft: "5px",
                                        }}
                                      />
                                    </IconButton>
                                  ) : user.odStatus ===
                                    "OD_COMPLETED_WITH_COMMUNICATION" ? (
                                    <IconButton size="small" color="info">
                                      <CircleIcon
                                        fontSize="small"
                                        sx={{
                                          width: "10px",
                                          marginLeft: "5px",
                                        }}
                                      />
                                    </IconButton>
                                  ) : user.odStatus ===
                                    "OD_COMPLETED_WITHOUT_COMMUNICATION" ? (
                                    <IconButton
                                      size="small"
                                      sx={{ color: "#3d6583" }}
                                    >
                                      <CircleIcon
                                        fontSize="small"
                                        sx={{
                                          width: "10px",
                                          marginLeft: "5px",
                                        }}
                                      />
                                    </IconButton>
                                  ) : user.odStatus === "OD_NOT_STARTED" ? (
                                    <IconButton size="small" color="error">
                                      <CircleIcon
                                        fontSize="small"
                                        sx={{
                                          width: "10px",
                                          marginLeft: "5px",
                                        }}
                                      />
                                    </IconButton>
                                  ) : null}
                                </div>
                                <span
                                  style={{ display: "flex" }}
                                  onClick={() =>
                                    modalImageHandle(user.image_url)
                                  }
                                >
                                  {user.image_url ? (
                                    <img
                                      src={user.image_url}
                                      alt="avtar"
                                      style={{
                                        height: "28px",
                                        width: "28px",
                                        borderRadius: "50%",
                                        marginRight: "0.9rem",
                                        objectFit: "cover",
                                        marginLeft: "0.9rem",
                                      }}
                                    />
                                  ) : (
                                    <AccountCircleIcon
                                      sx={{
                                        fontSize: "2rem",
                                        marginRight: "0.9rem",
                                        marginLeft: "0.9rem",
                                      }}
                                    />
                                  )}
                                </span>

                                <Typography sx={{ fontSize: "14px" }}>
                                  {user.name}
                                  {user.empCode
                                    ? ` (${user.empCode})`
                                    : " (NA)"}
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell>
                                {user.noOfCommunication && (
                                  <span
                                    className="comunicate"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => communicateHandle(user)}
                                  >
                                    {" "}
                                    {user.noOfCommunication}{" "}
                                  </span>
                                )}
                              </StyledTableCell>
                              <StyledTableCell>
                                <span className="cousor_pointer">
                                  {user.isInstantTracking ? (
                                    <LocationOnIcon
                                      onClick={(event) =>
                                        liveTracking(user.id, user.isRunning)
                                      }
                                    />
                                  ) : null}{" "}
                                </span>
                              </StyledTableCell>

                              <StyledTableCell>
                                <span className="">
                                  {Boolean(
                                    JSON.parse(localStorage.getItem("data"))
                                      ?.enableLiveTracking === true,
                                  ) && user.isODOn ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        // justifyContent: "flex-end",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        // flex: 1,
                                        // cursor: "pointer",
                                        columnGap: 7,
                                      }}
                                    >
                                      {user?.deviceName === "ANDROID" ? (
                                        <Tooltip title="ANDROID" arrow>
                                          {/* <AndroidIcon
                                            fontSize="small"
                                            sx={{ color: "#0f9809 !important" }}
                                          /> */}

                                          <img
                                            src={androidPng}
                                            alt="android"
                                            width="21px"
                                          />
                                        </Tooltip>
                                      ) : (
                                        <>
                                          {user?.deviceName === "IOS" ? (
                                            <Tooltip title="IOS" arrow>
                                              <AppleIcon fontSize="small" />
                                            </Tooltip>
                                          ) : null}
                                        </>
                                      )}
                                      <Tooltip title="Track Live" arrow>
                                        {/* <Box
                                          sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            paddingX: "4px",
                                            paddingY: "8.5px",
                                            borderRadius: "50%",
                                            transition:
                                              "background-color 0.3s ease",
                                            "&:Hover": {
                                              bgcolor: "#e0e0e0",
                                              transition:
                                                "background-color 0.3s ease",
                                            },
                                          }}
                                          onClick={(e) => {
                                            e?.preventDefault();
                                            e?.stopPropagation();
                                            handleTrackLive(user);
                                          }}
                                        >
                                          <img
                                            src={liveIcon}
                                            alt="liveIcon"
                                            width="21px"
                                            // onClick={(e) => {
                                            //   e?.preventDefault();
                                            //   e?.stopPropagation();
                                            //   handleTrackLive(user);
                                            // }}
                                          />
                                        </Box> */}

                                        <IconButton
                                          onClick={(e) => {
                                            e?.preventDefault();
                                            e?.stopPropagation();
                                            handleTrackLive(user);
                                          }}
                                        >
                                          <LocationOnIcon
                                            sx={{ color: "red" }}
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    </div>
                                  ) : null}
                                </span>
                              </StyledTableCell>
                            </StyledTableRow>
                          );
                        })}
                      {/* </TableBody> */}
                    </Table>
                    <Divider
                      sx={{ marginTop: "10px", marginBottom: "10px" }}
                    ></Divider>
                  </TableContainer>
                </Box>
              </Grid>
              <Grid item md={9} xs={12}>
                <Box
                  className="maponatinerBox"
                  style={{ height: "calc(100vh - 190px)" }}
                >
                  <MapComponent
                    userInfoTotal={userInfoTotal}
                    // userInfo={userInfo}
                    userInfo={singleUser ? singleDataShowOnMap : userInfo}
                    // userListData={userListData}
                    bound={bound}
                    isDashboard={true}
                    dashboardMapStyle={true}
                    style={{ width: "100%", height: "100% !important" }}
                  />
                </Box>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Box className="mein_label">
                  <Box className="border">
                    <IconButton size="small" color="success">
                      <CircleIcon fontSize="small" />
                    </IconButton>
                    <Typography variant="p">Form Submitted</Typography>
                  </Box>
                  <Box className="border">
                    <IconButton size="small" color="error">
                      <CircleIcon fontSize="small" />
                    </IconButton>
                    <Typography variant="p">No OD Started</Typography>
                  </Box>
                  <Box className="border">
                    <IconButton size="small" sx={{ color: "#E3C009" }}>
                      <CircleIcon fontSize="small" />
                    </IconButton>
                    <Typography variant="p">
                      OD Started but no Form Submitted
                    </Typography>
                  </Box>
                  <Box className="border">
                    <IconButton size="small" color="info">
                      <CircleIcon fontSize="small" />
                    </IconButton>
                    <Typography variant="p">
                      OD Completed With Form Submitted
                    </Typography>
                  </Box>
                  <Box className="border">
                    <IconButton size="small" sx={{ color: "#3d6583" }}>
                      <CircleIcon fontSize="small" />
                    </IconButton>
                    <Typography variant="p">
                      OD Completed But No Form Submitted
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
          {/* <Box
            sx={{
              marginTop: "1.5rem",
            }}
          >
            <Grid container spacing={2}>
              <Grid item md={9} xs={8}>
                <MapComponent
                  userInfoTotal={userInfoTotal}
                  bound={bound}
                  isDashboard={true}
                />
              </Grid>
              <Grid item md={3} xs={4}>
                <TableContainer>
                  <Table></Table>
                </TableContainer>
                <TableContainer
                  sx={{
                    height: "75vh",
                    minHeight: 440,
                  }}
                >
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>All</StyledTableCell>
                        <StyledTableCell>ON OD</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={2}>
                          <TextField
                            label="Search"
                            size="small"
                            fullWidth
                            autoFocus
                            onChange={(e) => {
                              handleSearch(e.target.value);
                              setSearch(e.target.value);
                            }}
                          />
                        </TableCell>
                      </TableRow>
                      {userInfo.map((user, index) => {
                        return (
                          <StyledTableRow
                            key={index}
                            hover
                            onClick={() => handleBound(user)}
                          >
                            <StyledTableCell
                              sx={{
                                display: "flex",
                              }}
                            >
                              {user.image_url ? (
                                <img
                                  src={user.image_url}
                                  alt="avtar"
                                  style={{
                                    height: "28px",
                                    width: "28px",
                                    borderRadius: "50%",
                                    marginRight: "0.5rem",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <AccountCircleIcon
                                  sx={{
                                    fontSize: "2rem",
                                    marginRight: "0.5rem",
                                  }}
                                />
                              )}
                              <Typography>
                                {user.name}{" "}
                                {user.empCode ? `(${user.empCode})` : ""}
                              </Typography>
                            </StyledTableCell>
                            <StyledTableCell>
                              {user.isODOn ? (
                                <IconButton size="small" color="success">
                                  <CircleIcon fontSize="small" />
                                </IconButton>
                              ) : user.isODCompleted ? (
                                <IconButton size="small" color="primary">
                                  <CircleIcon fontSize="small" />
                                </IconButton>
                              ) : null}
                            </StyledTableCell>
                          </StyledTableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Box> */}
        </Box>
      </ThemeProvider>
    </main>
  );
};

export default Dashboard;
